/**
 * How a Multi_Select field's selected values join into one string in generated documents and
 * report cells. Mirrors the Kotlin `RenderSeparator` enum. Null/absent on a field means COMMA.
 *
 * Note this never applies to `ee-tag` chip display, which renders one chip per value and so has
 * no joined string to separate.
 */
export enum RenderSeparator {
  COMMA = 'COMMA',
  SEMICOLON = 'SEMICOLON',
  AND = 'AND',
  OR = 'OR'
}

/**
 * The literal string a separator joins with — the client-side mirror of the Kotlin enum's
 * `separator` property, and it must stay identical to it or the same value reads differently
 * depending on whether the server or the browser rendered it.
 *
 * Null/absent means COMMA (Req 3.2), so an unknown or unset value falls there rather than throwing:
 * a newer client may know a constant this build does not.
 */
export function renderSeparatorString(separator: RenderSeparator | null | undefined): string {
  switch (separator) {
    case RenderSeparator.SEMICOLON:
      return '; ';
    case RenderSeparator.AND:
      return ' and ';
    case RenderSeparator.OR:
      return ' or ';
    default:
      return ', ';
  }
}

/** Picker entries for the editor dialogs, with an example of what each produces. */
export const RENDER_SEPARATOR_OPTIONS: { value: RenderSeparator, label: string }[] = [
  {value: RenderSeparator.COMMA, label: 'Comma (A, B, C)'},
  {value: RenderSeparator.SEMICOLON, label: 'Semicolon (A; B; C)'},
  {value: RenderSeparator.AND, label: 'And (A and B and C)'},
  {value: RenderSeparator.OR, label: 'Or (A or B or C)'}
];
